<script setup lang="ts">
import {ref} from "vue";
import {Button, Icon} from "@/Components/Library";
import Str from "@/Utils/Str";

interface Props {
    content: string;
}

const props = defineProps<Props>();
const isExpanded = ref(true);

const toggle = () => {
    isExpanded.value = !isExpanded.value;
};
</script>

<template>
    <div class="mb-2 w-full overflow-hidden">
        <div
            class="relative rounded-lg border border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-600 dark:bg-amber-900/20 dark:text-amber-200"
        >
            <div class="flex cursor-pointer items-center gap-2 p-3" @click="toggle">
                <Icon icon="mdi:alert" />
                <h4 class="font-semibold">Important Information</h4>
                <Button
                    text
                    icon="mdi:chevron-down"
                    :class="{'rotate-180': isExpanded}"
                    class="ml-auto !rounded-full !p-1 text-amber-600 transition-transform duration-200 hover:bg-amber-200 dark:text-amber-200 dark:hover:bg-amber-700"
                />
            </div>
            <div v-auto-animate>
                <div v-if="isExpanded" class="px-3 pb-3 text-sm">
                    <p v-html="Str.of(content).nl2br()" />
                </div>
            </div>
        </div>
    </div>
</template>
